import React from "react";
import { Col, Form, Row } from "react-bootstrap";
import { TerminalPOS } from "models/ECF/TerminalPOS";
import { SideInput } from "components/Inputs/SideBar/SideInput";
import InputContainer from "components/PantallasEdit/InputContainer/InputContainer";
import DropZone from "components/DropZone/Dropzone";
import IconButton from "components/IconButton/IconButton";
import SectionRow from "components/PantallasEdit/SectionRow/SectionRow";
import { ErrorBoundary } from "components/ErrorBoundary";
import EditSection from "components/PantallasEdit/EditSection/EditSection";
import { PerfilLookup } from "components/Lookups/PerfilLookup/PerfilLookup";
import { VendedorLookup } from "components/Lookups/VendedorLookup/VendedorLookup";


const TerminalPOSEdit = ({ terminalPOS, setTerminalPOS }) => {
    const handlePerfilChange = (event) => {
        if (event && event.value && event.value !== terminalPOS.PerfilId) {
            setTerminalPOS({
                ...terminalPOS,
                PerfilId: event.value,
            });
        } else {
            setTerminalPOS({
                ...terminalPOS,
                PerfilId: undefined,
            });
        }
    };

    const onFileChange = (files) => {
        setTerminalPOS({ ...terminalPOS, Img: files, _EliminarImagen: (files?.length ?? 0) === 0, ImagenBase64: null });
    };
    return (
        terminalPOS !== undefined && (
            <Col>
                <Form
                    action=""
                    className="form-horizontal"
                    id="TypeValidation"
                    method="">

                    <EditSection title={"Información General"}>
                        <SectionRow>
                            <SideInput
                                label="Nombre Dispositivo"
                                name="NombreDispositivo"
                                type="text"
                                value={terminalPOS?.NombreDispositivo || ""}
                                setState={setTerminalPOS}
                                required />

                            <SideInput
                                label="Modelo de Dispositivo"
                                name="ModeloDispositivo"
                                type="text"
                                value={terminalPOS?.ModeloDispositivo || ""}
                                setState={setTerminalPOS}
                                disabled={true}
                                required />

                        </SectionRow>

                        <SectionRow>
                            <SideInput
                                label="Version de SDK"
                                name="VersionSDK"
                                type="text"
                                value={terminalPOS?.VersionSDK || ""}
                                setState={setTerminalPOS}
                                enabled={false}
                                required />

                            <SideInput
                                label="Version de Firmware"
                                name="VersionFirmware"
                                type="text"
                                value={terminalPOS?.VersionFirmware || ""}
                                setState={setTerminalPOS}
                                enabled={false}
                                required />
                        </SectionRow>

                        <SectionRow>
                            <SideInput
                                label="IMEI"
                                name="IMEI"
                                type="text"
                                value={terminalPOS?.IMEI || ""}
                                setState={setTerminalPOS}
                                enabled={false}
                                required />

                            <SideInput
                                label="Estatus"
                                name="Estatus"
                                type="select"
                                value={terminalPOS?.Estatus || TerminalPOS.DEFAULT_ESTATUS_VALUE}
                                setState={setTerminalPOS}
                                disabled={!terminalPOS.IdSec}
                                options={TerminalPOS.ESTATUS_LIST} />
                        </SectionRow>
                    </EditSection>

                    <EditSection title={"Configuración"}>

                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                            {terminalPOS?.ImagenBase64 ? (
                                <InputContainer
                                    labelClassName={'d-flex'}
                                    rowStyle={{ width: '100%', display: 'flex', justifyContent: 'center' }}
                                    style={{ display: 'flex', justifyContent: 'center', width: '100%', textAlign: 'center' }}>
                                    <div style={{ display: 'flex', justifyContent: 'center', alignContent: 'center', gap: '1rem' }}>
                                        <div>
                                            <img src={
                                                terminalPOS.ImagenBase64?.startsWith("data:image")
                                                    ? terminalPOS.ImagenBase64
                                                    : `data:image/png;base64,${terminalPOS.ImagenBase64}`
                                            } alt="Imagen seleccionada"
                                                style={{ maxWidth: "250px", maxHeight: "250px" }} />
                                        </div>

                                        <IconButton styles={{ height: '2.5rem' }}  >
                                            <i className="fa fa-trash" onClick={() => setTerminalPOS({ ...terminalPOS, ImagenBase64: null, _EliminarImagen: true })}></i>
                                        </IconButton>
                                    </div>

                                </InputContainer>
                            ) : (
                                <InputContainer
                                    label="Logo"
                                    labelClassName={'d-flex'}
                                    ignoreColPadding={true}
                                    rowStyle={{ display: 'flex', justifyContent: 'center', width: '100%' }}
                                    style={{ display: 'flex', justifyContent: 'center', width: '100%', textAlign: 'center' }}>
                                    <div style={{ display: 'flex', justifyContent: 'center', gap: '1rem' }}>
                                        <DropZone
                                            className=""
                                            label="Seleccionar Imagen"
                                            updateFilesCb={onFileChange}
                                            multiple={false}
                                            type="image" />
                                    </div>
                                </InputContainer>
                            )}
                        </div>


                        <SectionRow>
                            <SideInput
                                label="Nombre Comercial"
                                name="NombreComercial"
                                type="text"
                                value={terminalPOS?.NombreComercial || ""}
                                setState={setTerminalPOS}
                                required />

                            <SideInput
                                label="Direccion"
                                name="Direccion"
                                type="text"
                                value={terminalPOS?.Direccion || ""}
                                setState={setTerminalPOS}
                                required />
                        </SectionRow>

                        <SectionRow>
                            <SideInput
                                label="Teléfono"
                                name="Telefono"
                                type="text"
                                value={terminalPOS?.Telefono || ""}
                                setState={setTerminalPOS}
                                required />

                            <SideInput
                                label="Email"
                                name="Email"
                                type="text"
                                value={terminalPOS?.Email || ""}
                                setState={setTerminalPOS}
                                required />
                        </SectionRow>

                        <SectionRow>
                            <ErrorBoundary>
                                <Form.Group>
                                    <Form.Label column sm="12" className="pl-0">Perfil</Form.Label>
                                    <PerfilLookup
                                        initialValue={{ value: terminalPOS.PerfilId }}
                                        onChange={handlePerfilChange}
                                        setState={setTerminalPOS}
                                        required />
                                </Form.Group>
                            </ErrorBoundary>

                            <ErrorBoundary>
                                <Form.Group>
                                    <Form.Label column sm="12" className="pl-0">Vendedor</Form.Label>
                                    <VendedorLookup
                                        initialValue={{ value: terminalPOS.VendedorId }}
                                        onChange={(e) =>
                                            setTerminalPOS({
                                                ...terminalPOS,
                                                VendedorId: e?.value,
                                            })} />
                                </Form.Group>
                            </ErrorBoundary>
                        </SectionRow>

                        <SectionRow>
                            <SideInput
                                label="Tipo"
                                name="TipoFacturacion"
                                type="select"
                                value={terminalPOS?.TipoFacturacion || TerminalPOS.TIPO_FACTURACION_LIST[0].value}
                                setState={setTerminalPOS}
                                options={TerminalPOS.TIPO_FACTURACION_LIST} />

                            <SideInput
                                label="Clave de seguridad"
                                name="ClaveSeguridad"
                                type="text"
                                value={terminalPOS?.ClaveSeguridad || ""}
                                setState={setTerminalPOS}
                                required />

                        </SectionRow>

                        <SectionRow>
                            <SideInput
                                label=""
                                placeholder="Permitir Cobros con Tarjeta"
                                name="PermitirCobrosConTarjeta"
                                value={terminalPOS?.PermitirCobrosConTarjeta || false}
                                type="check"
                                disabled={false}
                                setState={setTerminalPOS} />

                            <SideInput
                                label=""
                                placeholder="Solicitar Código de Vendedor"
                                name="SolicitarCodigoVendedor"
                                value={terminalPOS?.SolicitarCodigoVendedor || false}
                                type="check"
                                disabled={false}
                                setState={setTerminalPOS} />

                            <SideInput
                                label=""
                                placeholder="Imprimir Automáticamente"
                                name="ImprimirAutomaticamente"
                                value={terminalPOS?.ImprimirAutomaticamente || false}
                                type="check"
                                disabled={false}
                                setState={setTerminalPOS} />

                            <SideInput
                                label=""
                                placeholder="Solicitar Placa de Vehículo"
                                name="PedirPlaca"
                                value={terminalPOS?.PedirPlaca || false}
                                type="check"
                                disabled={false}
                                setState={setTerminalPOS} />
                        </SectionRow>
                    </EditSection>

                    <EditSection title={"Monto Límite por Comprobante"}>
                        <SectionRow>
                            <SideInput
                                label="Consumidor Final"
                                name="MontoLimite2"
                                type="number"
                                min={0}
                                value={terminalPOS?.MontoLimite2}
                                setState={setTerminalPOS} />

                            <SideInput
                                label="Crédito Fiscal"
                                name="MontoLimite1"
                                type="number"
                                min={0}
                                value={terminalPOS?.MontoLimite1}
                                setState={setTerminalPOS} />
                        </SectionRow>

                        <SectionRow>
                            <SideInput
                                label="Gubernamental"
                                name="MontoLimite3"
                                type="number"
                                min={0}
                                value={terminalPOS?.MontoLimite3}
                                setState={setTerminalPOS} />

                            <SideInput
                                label="Régimen Especial"
                                name="MontoLimite4"
                                type="number"
                                min={0}
                                value={terminalPOS?.MontoLimite4}
                                setState={setTerminalPOS} />
                        </SectionRow>
                    </EditSection>
                </Form>
            </Col>
        )
    );
};
export default TerminalPOSEdit;